<template>
  <el-drawer
    ref="drawer"
    title="授权列表"
    :before-close="handleClose"
    :visible.sync="drawer"
    direction="rtl"
    custom-class="edit_drawer"
    :wrapper-closable="false"
    :append-to-body="true"
    size="40%"
  >
    <div class="drawer__content">
      <div class="shuttle_content">
        <list-block class="shuttle_item">
          <div class="search">
            <el-input
              v-model="searchForm.customerKeyword"
              clearable
              :maxlength="50"
              placeholder="输入客户编码、客户简称、客户全称"
              @keyup.enter.native="fetchData(1,10)"
            />
            <el-button
              class="search_item"
              type="primary"
              @click="fetchData(1,10)"
            >
              查 询
            </el-button>
          </div>
          <el-table
            ref="customreRef"
            v-loading="loading.table"
            class="table_list"
            :data="customerList"
            border
            row-key="id"
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              type="selection"
              width="55"
              reserve-selection
            />
            <el-table-column
              v-for="item in LEFTAUTHTABLECOLUMN"
              :key="item.props"
              :prop="item.prop"
              :label="item.label"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <div v-if="item.prop === 'action'">
                  <el-button
                    type="text"
                    @click="InviteAuth(scope.row)"
                  >
                    取消授权
                  </el-button>
                </div>
                <span
                  v-else
                  v-text="item.formatter ? item.formatter(scope.row) : scope.row[item.prop]"
                />
              </template>
            </el-table-column>
          </el-table>
          <pagination
            ref="SitePagination"
            :total="pagination.total"
            :current-page.sync="pagination.page"
            :small="true"
            :layout="'total, prev, pager,next'"
            @search="fetchData"
          />
        </list-block>
        <list-block class="shuttle_item">
          <div class="search">
            <span>已选:{{ authList.length }}位客户</span>
            <el-button type="text" @click="handleAllClear">
              清空
            </el-button>
          </div>
          <el-table
            :data="selectList"
            class="table_list"
            border
          >
            <el-table-column
              v-for="item in RIGHTAUTHTABLECOLUMN"
              :key="item.props"
              :prop="item.prop"
              :label="item.label"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <div v-if="item.prop === 'action'">
                  <el-button
                    class="btn_table_item"
                    type="text"
                    @click="handleClear(scope.row)"
                  >
                    移除
                  </el-button>
                </div>
                <span
                  v-else
                  v-text="item.formatter ? item.formatter(scope.row) : scope.row[item.prop]"
                />
              </template>
            </el-table-column>
          </el-table>
          <pagination
            ref="SitePagination"
            :total="selectedPagination.total"
            :current-page.sync="selectedPagination.page"
            :layout="'total, prev, pager,next'"
            :small="true"
            @search="selectedPaging"
          />
        </list-block>
      </div>
      <div class="drawer__footer">
        <el-button @click="handleClose">
          关 闭
        </el-button>
        <el-button
          type="primary"
          :loading="loading.submit"
          @click="handleSubmit()"
        >
          保存
        </el-button>
      </div>
    </div>
  </el-drawer>
</template>

<script>
import { mainManageAuthAppend } from '@/api/principal';
import { customerList } from '@/api/taskCenter';
import ListBlock from '@/components/ListBlock/index.vue';
import pagination from '@/components/Pagination/index.vue';
import { LEFTAUTHTABLECOLUMN, RIGHTAUTHTABLECOLUMN } from '../constant';

export default {
  name: 'AddAuth',
  components: {
    ListBlock,
    pagination,
  },
  data() {
    return {
      LEFTAUTHTABLECOLUMN,
      RIGHTAUTHTABLECOLUMN,
      drawer: false,
      loading: {
        table: false,
        submit: false,
      },
      pagination: {
        total: null,
        page: 1,
        size: 10,
      },
      selectedPagination: {
        total: null,
        page: 1,
        size: 10,
      },
      authList: [], // 已授权列表
      customerList: [], // 客户列表
      form: {},
      searchForm: {},
      config: {},
    };
  },
  computed: {
    selectList() {
      return this.authList.slice((this.selectedPagination.page - 1) * this.selectedPagination.size, (this.selectedPagination.page - 1) * this.selectedPagination.size + this.selectedPagination.size);
    },
  },
  methods: {
    show(config) {
      this.config = config;
      this.fetchData();
      this.drawer = true;
    },
    handleClose() {
      this.searchForm = {};
      this.authList = [];
      this.pagination.page = 1;
      this.selectedPagination.page = 1;
      this.$refs.customreRef.clearSelection();
      this.drawer = false;
    },
    async fetchData(page, size) {
      this.loading.table = true;
      this.pagination.page = page || this.pagination.page;
      this.pagination.size = size || this.pagination.size;
      try {
        const res = await customerList({
          ...this.searchForm,
          isQueryAll: true,
          ignoreTenant: true,
        }, { page: this.pagination.page, size: this.pagination.size });
        this.customerList = res.records;
        this.pagination.total = res.total;
        this.loading.table = false;
      } catch (error) {
        this.loading.table = false;
      }
    },
    selectedPaging(page, size) {
      this.selectedPagination.page = page || this.selectedPagination.page;
      this.selectedPagination.size = size || this.selectedPagination.size;
    },
    addAuthorization() {},
    handleClear(row) {
      this.authList.splice(this.authList.findIndex((item) => item.id === row.id), 1);
      this.$refs.customreRef.toggleRowSelection(row, false);
    },
    handleAllClear() {
      this.authList = [];
      this.$refs.customreRef.clearSelection();
    },
    async handleSubmit() {
      if (!this.authList.length) {
        this.$message.warning('未选择授权客户');
        return;
      }
      this.loading.submit = true;
      const authCustomers = this.authList.map((item) => ({
        customerId: item.id,
        customerCode: item.customerCode,
        customerName: item.customerAllName,
        customerShortName: item.customerName,
      }));
      try {
        await mainManageAuthAppend({ authCustomers, creditCode: this.config.creditCode });
        this.loading.submit = false;
        this.$message.success('授权成功');
        this.handleClose();
        this.$emit('reset');
      } catch (error) {
        this.loading.submit = false;
      }
    },
    handleSelectionChange(val) {
      this.authList = val.reverse();
      this.selectedPagination.total = this.authList.length;
      if (this.selectedPagination.total / 10 < this.selectedPagination.page) {
        this.selectedPagination.page = this.selectedPagination.total / 10 < 1 ? 1 : Math.ceil(this.selectedPagination.total / 10);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
 ::v-deep .edit_drawer {
 .el-drawer__body{
  padding: 0 !important;
}
}
.drawer__content{
  padding: 24px;
  margin-bottom: 68px;
}
.drawer__footer{
  z-index: 100;
  background: #fff;
  position: absolute;
  bottom: 0;
  left: 0;
  padding: 16px 24px;
  width: calc(100% - 48px);
  border-top: 1px solid #EBEEF5;
  text-align: right;
}
  .search{
    margin-bottom: 24px;
    display:flex;
    align-items: center;
    justify-content: space-between;
    margin-right: 40px;
    .search_item{
      margin-left: 12px;
    }
  }
.shuttle_content{
  height: 100%;
  display: flex;
}
.shuttle_item{
  width: calc(50% - 24px);
  border-right: 1px solid #EBEEF5;
  margin-top: 0px;
}
.shuttle_item:last-child{
  border-right:0px;
}
.table_list{
  overflow-y: auto;
  min-height: calc(100% - 240px);
}
.btn_table_item{
  height: 20px;
}
</style>
